import { render, staticRenderFns } from "./ArqTable.vue?vue&type=template&id=666e1452&scoped=true&"
import script from "./ArqTable.vue?vue&type=script&lang=js&"
export * from "./ArqTable.vue?vue&type=script&lang=js&"
import style0 from "./ArqTable.vue?vue&type=style&index=0&id=666e1452&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e1452",
  null
  
)

export default component.exports